import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

const useGroup = () => {
    const callApi = useCallApi()
    const [group, setGroup] = useState([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet<any>({
                url: umServinceURL.getLookupGroup,
            })
            setGroup(data.result)
        } catch (error) {
            console.log('error', error)
        }
    }

    return { group }
}

export default useGroup
